import { render, staticRenderFns } from "./EventDetailsSection.vue?vue&type=template&id=b6ee3880"
import script from "./EventDetailsSection.vue?vue&type=script&lang=ts"
export * from "./EventDetailsSection.vue?vue&type=script&lang=ts"
import style0 from "./EventDetailsSection.vue?vue&type=style&index=0&id=b6ee3880&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports